module.exports = __webpack_public_path__ + "img/gastronomy.d411f8b7.svg";